module.exports = __webpack_public_path__ + "img/18.107.A.2b067e7a.png";